
// const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@gmail\.com$/ ; 
const EMAIL_PATTERN = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/ ; 
const PASS_PATTERN = /^[A-Z][a-zA-Z0-9!@#$%^&*()_+]{8,}$/;


// For Validate Email 
export const validEmail = (email)=>{
    return EMAIL_PATTERN.test(email); 
}


// For ValidatePassword
export const validPassword = (pass)=>{
    return PASS_PATTERN.test(pass)
}

// For Confirmed Password
export const confirmedPassword = (pass , confirmPass)=>{
    if(pass === confirmPass) { 
        return true ;
    }else{
        return false ;
    }
}

export const notEmpty = (text)=>{
    if(text !== ""){
        return true
    }else{
        return false
    }
}